# 项目分组

tower.initProjectGroups = ->
  $('.init-project-groups, .init-project-stars').hide()
  bind()
  checkStore()

bind = ->
  key = "#{ simple.url().toString('relative') }project-group"
  $groups = $('.project-groups')
  $groups.on 'click', '.project-group', ->
    $btn = $(@).addClass('active').siblings('.active').removeClass 'active'
    group = $groups.find('.project-group.active').data('group-id')
    filterProjects group
    simple.util.storage.set key, group

tower.getCurrentProjectGroup = ->
  group = $('.project-groups .project-group.active')
  if group
    group.data('group-id')
  else
    'all'

tower.filterProjectsHelper = ($el, group) ->
  if group is 'all'
    $el.find('.project').show()
  else if group is 'stars'
    # do nothing
  else
    $el.find('.project').hide()
    $el.find(".project[data-group-ids*='#{ group }']").show()

filterProjects = (group) ->
  if group is 'stars'
    $('.projects .project').hide()
    $('.pin-projects .project').show()
  else
    tower.filterProjectsHelper $('.projects'), group
    tower.filterProjectsHelper $('.pin-projects'), group
  tower.filterInitProject(group) unless tower.isAutoLoadProjectsCompleted()


tower.filterInitProject = (group) ->
  $(if group is 'stars' then '.init-project-groups' else '.init-project-stars')
    .hide()
  $(if group is 'stars' then '.init-project-stars' else '.init-project-groups')
    .toggle $('.project:visible').length is 0

allAvailableGroups = ->
  groups = []
  $('.project-groups .project-group').each ->
    groups.push $(@).data('group-id')
  groups

checkStore = (key) ->
  key = "#{ simple.url().toString('relative') }project-group"
  group = simple.util.storage.get(key) or 'all'
  group = 'all' if allAvailableGroups().indexOf(group) == -1
  try
    $(".project-group[data-group-id='#{group}']").trigger('click')